__turbopack_context__.v({
  "buttonContainer": "styles-module-scss-module__RgbBgG__buttonContainer",
  "dropdown": "styles-module-scss-module__RgbBgG__dropdown",
  "dropdownContainer": "styles-module-scss-module__RgbBgG__dropdownContainer",
  "dropdownHeader": "styles-module-scss-module__RgbBgG__dropdownHeader",
  "dropdownWrapper": "styles-module-scss-module__RgbBgG__dropdownWrapper",
  "expand": "styles-module-scss-module__RgbBgG__expand",
  "infoButton": "styles-module-scss-module__RgbBgG__infoButton",
  "labelRow": "styles-module-scss-module__RgbBgG__labelRow",
  "mantine-Pill-root": "styles-module-scss-module__RgbBgG__mantine-Pill-root",
  "open": "styles-module-scss-module__RgbBgG__open",
  "openUpward": "styles-module-scss-module__RgbBgG__openUpward",
  "sizeButton": "styles-module-scss-module__RgbBgG__sizeButton",
  "sizeGroup": "styles-module-scss-module__RgbBgG__sizeGroup",
  "title": "styles-module-scss-module__RgbBgG__title",
});
